import { motion } from "framer-motion";

/**
 * Slow editorial marquee — infinite loop of a text line.
 * Uses translateX with framer-motion's repeat + linear ease.
 */
export default function Marquee({
  items = [],
  duration = 45,
  className = "",
  separator = "·",
}) {
  const content = items.length ? items : ["Bespoke Joinery", "Private Construction", "3D Design", "Since 2000", "London"];
  const line = content.flatMap((t, i) => (i === 0 ? [t] : [separator, t]));

  return (
    <div
      data-testid="marquee"
      className={`relative overflow-hidden border-y border-edge py-8 md:py-10 select-none ${className}`}
    >
      <motion.div
        className="flex whitespace-nowrap gap-16 font-display italic text-4xl md:text-6xl lg:text-7xl text-ink"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration, ease: "linear", repeat: Infinity }}
      >
        {[0, 1].map((set) => (
          <div key={set} className="flex items-center gap-16 shrink-0">
            {line.map((it, i) => (
              <span
                key={`${set}-${i}`}
                className={
                  it === separator
                    ? "text-brand text-3xl md:text-5xl"
                    : ""
                }
              >
                {it}
              </span>
            ))}
            <span className="text-brand text-3xl md:text-5xl">{separator}</span>
          </div>
        ))}
      </motion.div>
    </div>
  );
}
